export default __webpack_public_path__ + "static/media/merge_workflow.b4c6c35c.svg";